@if (searchEnabled ? true : elCount > 0) {
  <rt-dropdown>
    @if (searchEnabled) {
      <rt-form-field margin-small-x>
        <rt-input
          [autoFocus]="true"
          [formControl]="searchFormControl"
          placeholder="Search..."
          variant="rounded"
        >
          <rt-icon prefix name="search" />
        </rt-input>
      </rt-form-field>
    }

    <div class="items-container">
      @for (group of groupedData; track trackByValue(groupIndex, group); let groupIndex = $index) {
        <div>
          @if (group.data.length) {
            @if (group.header) {
              <rt-dropdown-header [fullWidthTitle]="true" [isSubheading]="true">
                {{ group.header }}
              </rt-dropdown-header>
            }
            @for (el of group.data; track trackByMention(index, el); let index = $index) {
              <rt-dropdown-item
                #tooltipList="rtTooltip"
                (click)="handleClick(group, el, $event)"
                (mouseenter)="onElementHover(index, groupIndex)"
                (mousedown)="$event.stopImmediatePropagation(); $event.preventDefault()"
                [rtTooltip]="el.tooltip"
                [rtTooltipPosition]="tooltipPosition"
                [highlighted]="computedIndex(index, groupIndex) === highlightedIndex"
                [highlightColor]="group.disabled ? 'disabled' : 'blue'"
                [hasHoverEffect]="false"
                [class.cursor-pointer]="!group.disabled"
                [class.disabled]="group.disabled"
              >
                <div class="item">
                  <rt-avatar
                    [imageSrc]="$any(el.avatar)"
                    [type]="el.hasAvatar ? 'image' : 'initials'"
                    [initials]="el.initials"
                    size="small-x"
                    shape="oval"
                    context="admin"
                    margin-right-small-x
                  />
                  <rt-truncate>{{ el.name }}</rt-truncate>
                </div>
              </rt-dropdown-item>
            }
          }
        </div>
      }
    </div>
  </rt-dropdown>
}
